/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendCountryDto } from '../models/backend-country-dto';
import { BackendCurrencyDto } from '../models/backend-currency-dto';
import { BackendFinancingSourceDto } from '../models/backend-financing-source-dto';
import { BackendIndustryDto } from '../models/backend-industry-dto';
import { BackendProjectFieldDto } from '../models/backend-project-field-dto';
import { projectsCountriesList } from '../fn/projects-sectors/projects-countries-list';
import { ProjectsCountriesList$Params } from '../fn/projects-sectors/projects-countries-list';
import { projectsCurrenciesList } from '../fn/projects-sectors/projects-currencies-list';
import { ProjectsCurrenciesList$Params } from '../fn/projects-sectors/projects-currencies-list';
import { BackendProjectsEnumsDto } from '../models/backend-projects-enums-dto';
import { projectsFinancingSourcesList } from '../fn/projects-sectors/projects-financing-sources-list';
import { ProjectsFinancingSourcesList$Params } from '../fn/projects-sectors/projects-financing-sources-list';
import { projectsIndustriesList } from '../fn/projects-sectors/projects-industries-list';
import { ProjectsIndustriesList$Params } from '../fn/projects-sectors/projects-industries-list';
import { projectsProjectFieldsList } from '../fn/projects-sectors/projects-project-fields-list';
import { ProjectsProjectFieldsList$Params } from '../fn/projects-sectors/projects-project-fields-list';
import { projectsProjectsEnumsRetrieve } from '../fn/projects-sectors/projects-projects-enums-retrieve';
import { ProjectsProjectsEnumsRetrieve$Params } from '../fn/projects-sectors/projects-projects-enums-retrieve';
import { projectsRegionsList } from '../fn/projects-sectors/projects-regions-list';
import { ProjectsRegionsList$Params } from '../fn/projects-sectors/projects-regions-list';
import { projectsSegmentsList } from '../fn/projects-sectors/projects-segments-list';
import { ProjectsSegmentsList$Params } from '../fn/projects-sectors/projects-segments-list';
import { BackendRegionDto } from '../models/backend-region-dto';
import { BackendSegmentDto } from '../models/backend-segment-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiProjectsSectorsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsCountriesList()` */
  static readonly ProjectsCountriesListPath = '/api/projects/countries/';

  /**
   * Страны.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsCountriesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsCountriesList$Response(
    params?: ProjectsCountriesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendCountryDto>>> {
    return projectsCountriesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Страны.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsCountriesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsCountriesList(
    params?: ProjectsCountriesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendCountryDto>> {
    return this.projectsCountriesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendCountryDto>>): Array<BackendCountryDto> => r.body),
    );
  }

  /** Path part for operation `projectsCurrenciesList()` */
  static readonly ProjectsCurrenciesListPath = '/api/projects/currencies/';

  /**
   * Валюты.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsCurrenciesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsCurrenciesList$Response(
    params?: ProjectsCurrenciesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendCurrencyDto>>> {
    return projectsCurrenciesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Валюты.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsCurrenciesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsCurrenciesList(
    params?: ProjectsCurrenciesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendCurrencyDto>> {
    return this.projectsCurrenciesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendCurrencyDto>>): Array<BackendCurrencyDto> => r.body),
    );
  }

  /** Path part for operation `projectsFinancingSourcesList()` */
  static readonly ProjectsFinancingSourcesListPath = '/api/projects/financing-sources/';

  /**
   * Источники финансирования проекта.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsFinancingSourcesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsFinancingSourcesList$Response(
    params?: ProjectsFinancingSourcesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendFinancingSourceDto>>> {
    return projectsFinancingSourcesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Источники финансирования проекта.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsFinancingSourcesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsFinancingSourcesList(
    params?: ProjectsFinancingSourcesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendFinancingSourceDto>> {
    return this.projectsFinancingSourcesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendFinancingSourceDto>>): Array<BackendFinancingSourceDto> => r.body),
    );
  }

  /** Path part for operation `projectsIndustriesList()` */
  static readonly ProjectsIndustriesListPath = '/api/projects/industries/';

  /**
   * Индустрии проекта.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsIndustriesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsIndustriesList$Response(
    params?: ProjectsIndustriesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendIndustryDto>>> {
    return projectsIndustriesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Индустрии проекта.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsIndustriesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsIndustriesList(
    params?: ProjectsIndustriesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendIndustryDto>> {
    return this.projectsIndustriesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendIndustryDto>>): Array<BackendIndustryDto> => r.body),
    );
  }

  /** Path part for operation `projectsProjectFieldsList()` */
  static readonly ProjectsProjectFieldsListPath = '/api/projects/project-fields/';

  /**
   * Поля в проекте.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectFieldsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectFieldsList$Response(
    params?: ProjectsProjectFieldsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendProjectFieldDto>>> {
    return projectsProjectFieldsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Поля в проекте.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectFieldsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectFieldsList(
    params?: ProjectsProjectFieldsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendProjectFieldDto>> {
    return this.projectsProjectFieldsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendProjectFieldDto>>): Array<BackendProjectFieldDto> => r.body),
    );
  }

  /** Path part for operation `projectsProjectsEnumsRetrieve()` */
  static readonly ProjectsProjectsEnumsRetrievePath = '/api/projects/projects/enums/';

  /**
   * Енумы проекта.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsEnumsRetrieve$Response(
    params?: ProjectsProjectsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectsEnumsDto>> {
    return projectsProjectsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Енумы проекта.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsEnumsRetrieve(
    params?: ProjectsProjectsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendProjectsEnumsDto> {
    return this.projectsProjectsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectsEnumsDto>): BackendProjectsEnumsDto => r.body),
    );
  }

  /** Path part for operation `projectsRegionsList()` */
  static readonly ProjectsRegionsListPath = '/api/projects/regions/';

  /**
   * Регионы проекта с фильтром по стране.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsRegionsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsRegionsList$Response(
    params?: ProjectsRegionsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendRegionDto>>> {
    return projectsRegionsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Регионы проекта с фильтром по стране.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsRegionsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsRegionsList(params?: ProjectsRegionsList$Params, context?: HttpContext): Observable<Array<BackendRegionDto>> {
    return this.projectsRegionsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendRegionDto>>): Array<BackendRegionDto> => r.body),
    );
  }

  /** Path part for operation `projectsSegmentsList()` */
  static readonly ProjectsSegmentsListPath = '/api/projects/segments/';

  /**
   * сегменты проекта.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsSegmentsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsSegmentsList$Response(
    params?: ProjectsSegmentsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendSegmentDto>>> {
    return projectsSegmentsList(this.http, this.rootUrl, params, context);
  }

  /**
   * сегменты проекта.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsSegmentsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsSegmentsList(
    params?: ProjectsSegmentsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendSegmentDto>> {
    return this.projectsSegmentsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendSegmentDto>>): Array<BackendSegmentDto> => r.body),
    );
  }
}
